import { buildApi } from '../util/api.util';

export const onboardingapi = buildApi(process.env.REACT_APP_ONBOARDING_URL!);
